import React, { useState } from 'react'
import clsx from 'clsx'

import { Card, CardHeader, CardContent, Collapse, IconButton, makeStyles } from '@material-ui/core'

import { useTheme } from '@material-ui/core/styles'

import { ExpandMoreOutlined } from '@material-ui/icons'

import AddOnsTable from '../Tables/AddOnsTable'

import moment from 'moment'

const useStyles = makeStyles((theme) => ({
	card: {
		backgroundColor: '#F9F9F9',
		boxShadow: 'none'
	},
	header: {
		padding: '13px 24px',
		'& .MuiCardHeader-action': {
			margin: 0
		},
		'& .MuiCardHeader-title': {
			textTransform: 'none'
		}
	},
	expand: {
		transform: 'rotate(0deg)',
		marginLeft: 'auto',
		transition: theme.transitions.create('transform', {
			duration: theme.transitions.duration.shortest
		}),
		padding: 0
	},
	expandOpen: {
		transform: 'rotate(180deg)'
	},
	sectionsWrapper: {
		display: 'flex',
		justifyContent: 'space-between',
		flexWrap: 'wrap',
		maxWidth: '68%'
	}
}))

const CreateVisitPetDetailDayDropdown = (props) => {
	const theme = useTheme()
	const classes = useStyles(theme)
	const { date, pet, visit } = props
	const [isExpanded, setIsExpanded] = useState(false)

	return (
		<Card className={classes.card}>
			<CardHeader
				className={classes.header}
				title={date}
				onClick={() => setIsExpanded(!isExpanded)}
				// action={
				// <IconButton
				//   className={ clsx(classes.expand, { [classes.expandOpen]: isExpanded }) }
				//   onClick={ () => setIsExpanded(!isExpanded) }
				//   aria-expanded={ isExpanded }
				//   aria-label="show more"
				// >
				//   <ExpandMoreOutlined style={{ fill: '#777679' }} />
				// </IconButton>
				// }
			/>
			{/* <Collapse in={ isExpanded } timeout="auto" unmountOnExit>
        <CardContent>
          <AddOnsTable pet={ pet } addOns={ pet.add_on_services ? pet.add_on_services.filter(add_on_service => moment(add_on_service.date).isSame(moment(date)) && add_on_service.visit_id === visit._id) : [] } />
        </CardContent>
      </Collapse> */}
		</Card>
	)
}

export default CreateVisitPetDetailDayDropdown
